import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientBackendMockService } from './patient-backend.service.mock.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  providers: [],
  exports: []
})
export class PatientBackendMockModule {
  constructor(private service: PatientBackendMockService) {
  }
  static forRoot(): ModuleWithProviders<PatientBackendMockModule> {
    return {
      ngModule: PatientBackendMockModule,
      providers: [PatientBackendMockService]
    };
  }
}

